
import AutoSelectionSidebar from "./AutoSelectionSidebar";
import AutoSelectedQuestions from "./AutoSelectedQuestions";

const AutoSelectionTab = ({
  newAutoSelection,
  setNewAutoSelection,
  autoSelections,
  setAutoSelections,
  categoriesData,
  getSubCategories,
  handleAutoSelectionAdd,
  handleAutoSelectionRemove,
  handleAutoSelectQuestions,
  // Props for questions display
  selectedQuestions,
  handleQuestionToggle,
  setShowSelectedQuestions,
}) => {
  const handleRemoveQuestion = (questionId) => {
    const questionToRemove = selectedQuestions.find(q => q._id === questionId);
    if (questionToRemove && handleQuestionToggle) {
      handleQuestionToggle(questionToRemove);
    }
  };

  return (
    <div className="flex h-[600px] border rounded-lg overflow-hidden">
      <AutoSelectionSidebar
        newAutoSelection={newAutoSelection}
        setNewAutoSelection={setNewAutoSelection}
        autoSelections={autoSelections}
        categoriesData={categoriesData}
        handleAutoSelectionAdd={handleAutoSelectionAdd}
        handleAutoSelectionRemove={handleAutoSelectionRemove}
        handleAutoSelectQuestions={handleAutoSelectQuestions}
      />
      <div className="flex-1 p-4 overflow-y-auto">
        <AutoSelectedQuestions
          selectedQuestions={selectedQuestions}
          onRemoveQuestion={handleRemoveQuestion}
          onViewAll={() => setShowSelectedQuestions && setShowSelectedQuestions(true)}
        />
      </div>
    </div>
  );
};

export default AutoSelectionTab;
